import {Injectable} from '@angular/core';
import {Column} from '../_models/report/column';
import {Organization} from '../_models/organization';
import {ColumnFormats} from '../_constants/column-formats';
import {OrganizationService} from './organization.service';
import {UnderscoreConversionPipe} from '../_components/_pipes/underscore-conversion.pipe';
import {formatDayOfWeek, formatHour, formatMonth, formattedMilli} from '../_utils/date-utils';
import {CurrencyPipe, DatePipe, PercentPipe} from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class ColumnFormatterService {
    organization: Organization;
    timezone = '+0000';

    constructor(
        private organizationService: OrganizationService,
        private currencyPipe: CurrencyPipe,
        private percentPipe: PercentPipe,
        private datePipe: DatePipe,
        private underscoreConversionPipe: UnderscoreConversionPipe
    ) {
        this.organizationService.current.subscribe(o => {
            this.organization = !!o ? new Organization(o) : null;
            this.timezone = (!!this.organization
                && !!this.organization.organizationPreference
                && !!this.organization.organizationPreference.timeZone)
                ? this.organization.organizationPreference.timeZone
                : '+0000';
        });
    }

    formatValue(value: any, column: Column) {
        if (!!column && !!column.aggregation && column.aggregation === 'COUNT') {
            return this.getNumeric(value);
        } else if (!!column) {
            return this.formatValueWithFormat(value, column.format);
        } else {
            return value;
        }
    }

    formatValueWithFormat(value: any, format: string) {
        switch (format) {
        case ColumnFormats.CURRENCY:
            return this.currencyPipe.transform(this.getNumeric(value));
        case ColumnFormats.PERCENT:
            return this.percentPipe.transform(value, '1.0-1');
        case ColumnFormats.DAY_OF_WEEK:
            return formatDayOfWeek(value);
        case ColumnFormats.HOUR:
            return formatHour(value);
        case ColumnFormats.MONTH:
            return formatMonth(value);
        case ColumnFormats.DURATION:
            return formattedMilli(value);
        case ColumnFormats.DATE:
            return this.datePipe.transform(value, 'shortDate', '+0000');
        case ColumnFormats.DATE_TIME:
            return this.datePipe.transform(value, 'short', this.timezone);
        case ColumnFormats.NUMBER:
        case ColumnFormats.ID:
            return this.getNumeric(value);
        case ColumnFormats.UNDERSCORE:
            return this.underscoreConversionPipe.transform(value);
        }
        return value;
    }

    getNumeric(value: string) {
        return !!value ? this.round(Number.parseFloat(value)) : 0;
    }

    round(num: number) {
        const m = Number((Math.abs(num) * 100).toPrecision(15));
        return Math.round(m) / 100 * Math.sign(num);
    }
}
